import masonry01 from './img/masonry01.jpg';
import masonry02 from './img/masonry02.jpg';
import masonry03 from './img/masonry03.jpg';
import masonry09 from './img/masonry09.jpg';
import masonry10 from './img/masonry10.jpg';
import masonry11 from './img/masonry11.jpg';
import masonry12 from './img/masonry12.jpg';
import masonry13 from './img/masonry13.jpg';
import masonry14 from './img/masonry14.jpg';
import masonry15 from './img/masonry15.jpg';
import masonry16 from './img/masonry16.jpg';
import masonry17 from './img/masonry17.png';
import masonry18 from './img/masonry18.png';
import masonry19 from './img/masonry19.png';
import masonry20 from './img/masonry20.png';
import masonry21 from './img/masonry21.png';
import masonry22 from './img/masonry22.png';
import masonry23 from './img/masonry23.png';
import masonry24 from './img/masonry24.png';
import masonry25 from './img/masonry25.png';
import masonry26 from './img/masonry26.png';
import masonry27 from './img/masonry27.png';
import masonry28 from './img/masonry28.JPG';
import masonry29 from './img/masonry29.jpg';
import masonry30 from './img/masonry30.jpg';
import masonry31 from './img/masonry31.jpg';
import masonry32 from './img/masonry32.jpg';
import masonry33 from './img/masonry33.jpg';

export const images = [
    { src: masonry01, category: 'Студио' },
    { src: masonry16, category: 'Behind The Scenes' },
    { src: masonry03, category: 'Студио' },
    { src: masonry22, category: 'Behind The Scenes' },
    { src: masonry09, category: 'Студио' },
    { src: masonry10, category: 'Студио' },
    { src: masonry21, category: 'Behind The Scenes' },
    { src: masonry12, category: 'Студио' },
    { src: masonry13, category: 'Студио' },
    { src: masonry18, category: 'Behind The Scenes' },
    { src: masonry14, category: 'Студио' },
    { src: masonry15, category: 'Студио' },
    { src: masonry17, category: 'Behind The Scenes' },
    { src: masonry02, category: 'Студио' },
    { src: masonry19, category: 'Behind The Scenes' },
    { src: masonry11, category: 'Студио' },
    { src: masonry20, category: 'Behind The Scenes' },
    { src: masonry23, category: 'Behind The Scenes' },
    { src: masonry33, category: 'Студио' },
    { src: masonry25, category: 'Behind The Scenes' },
    { src: masonry31, category: 'Студио' },
    { src: masonry27, category: 'Behind The Scenes' },
    { src: masonry28, category: 'Студио' },
    { src: masonry29, category: 'Студио' },
    { src: masonry26, category: 'Behind The Scenes' },
    { src: masonry30, category: 'Студио' },
    { src: masonry24, category: 'Behind The Scenes' },
    { src: masonry32, category: 'Студио' },
];